import {CommonModule} from '@angular/common';
import {Component, Input} from '@angular/core';
import {OperationalWarningView} from '../operational-readiness.models';

/**
 * Presentation-only warning card.
 * Renders Problem → Impact → Recommended Action (optional scope/condition).
 */
@Component({
    selector: 'app-operational-warning-card',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './operational-warning-card.component.html',
    styleUrl: './operational-warning-card.component.css',
})
export class OperationalWarningCardComponent {
    @Input({required: true}) warning!: OperationalWarningView;

    get scopeLabel(): string {
        if (this.warning?.scope === 'platform') {
            return 'Platform';
        }
        if (this.warning?.scope === 'organization') {
            return 'Organization';
        }
        return '';
    }
}
